import inquirer from 'inquirer';
import chalk from 'chalk';

/**
 * Prompt user for confirmation
 */
export async function confirm(message: string, defaultValue = false): Promise<boolean> {
  const { confirmed } = await inquirer.prompt([
    {
      type: 'confirm',
      name: 'confirmed',
      message,
      default: defaultValue,
    },
  ]);
  return confirmed;
}

/**
 * Prompt user to select from a list
 */
export async function select<T extends string>(
  message: string,
  choices: T[],
  defaultChoice?: T
): Promise<T> {
  const { selected } = await inquirer.prompt([
    {
      type: 'list',
      name: 'selected',
      message,
      choices,
      default: defaultChoice,
    },
  ]);
  return selected;
}

/**
 * Prompt user with multiple choice selection
 */
export async function multiSelect<T extends string>(
  message: string,
  choices: T[],
  defaultChoices?: T[]
): Promise<T[]> {
  const { selected } = await inquirer.prompt([
    {
      type: 'checkbox',
      name: 'selected',
      message,
      choices,
      default: defaultChoices,
    },
  ]);
  return selected;
}

/**
 * Prompt user for text input
 */
export async function input(message: string, defaultValue?: string): Promise<string> {
  const { answer } = await inquirer.prompt([
    {
      type: 'input',
      name: 'answer',
      message,
      default: defaultValue,
    },
  ]);
  return answer;
}

/**
 * Display a success message
 */
export function success(message: string): void {
  console.log(chalk.green('✓'), message);
}

/**
 * Display an error message
 */
export function error(message: string): void {
  console.log(chalk.red('✗'), message);
}

/**
 * Display a warning message
 */
export function warning(message: string): void {
  console.log(chalk.yellow('⚠'), message);
}

/**
 * Display an info message
 */
export function info(message: string): void {
  console.log(chalk.blue('ℹ'), message);
}

/**
 * Display a tip message
 */
export function tip(message: string): void {
  console.log(chalk.cyan('💡'), chalk.dim(message));
}

/**
 * Format a date in a readable way
 */
export function formatDate(date: Date): string {
  return chalk.dim(date.toLocaleString());
}

/**
 * Create a divider line
 */
export function divider(): void {
  console.log(chalk.dim('─'.repeat(50)));
}
